// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"5bf7e833","884":"8311e4aa"}[chunkId] + ".chunk.css";
};